export default {
    appName: "Logowinx",
    documentTitle: "Buyer Dashboard | Logowinx",
    domain: 'https://www.logowinx.com',
    // domain: 'http://127.0.0.1:8000',
    localUserKey: "logowinx_userdata"
}
